import NotificationOrderInterval from "../symbols/notificationOrderInterval";

const notificationOrderIntervalSetIntervalAction = (interval: number) => ({
  type: NotificationOrderInterval.SET_NOTIFICATION_ORDER_INTERVAL,
  payload: interval,
});
const clearNotificationOrderIntervalAction = () => ({
  type: NotificationOrderInterval.SET_NOTIFICATION_ORDER_INTERVAL,
});

export function setNotificationOrderInterval(interval: number) {
  return (dispatch: any) => {
    dispatch(notificationOrderIntervalSetIntervalAction(interval));
  };
}
export function clearNotificationOrderInterval() {
  return (dispatch: any) => {
    dispatch(clearNotificationOrderIntervalAction());
  };
}
